import { create } from 'zustand';

type ListState = {
  refreshKey: number;
  resetKey: number;
  refreshList: () => void;
  resetList: () => void;
}

const usePrepaymentList = create<ListState>((set, get) => ({
  refreshKey: 0,
  resetKey: 0,
  refreshList: () => set({refreshKey: get().refreshKey + 1}),
  resetList: () => set({resetKey: get().resetKey + 1})
}));

export default usePrepaymentList;
